<template>
  <div class="max-w-3xl pb-20 px-2 lg:px-4 flex-1 flex flex-col items-center justify-center p-6 text-center">
    <div class="feedback-card max-w-lg w-full p-10 md:p-12 rounded-[2.5rem] animate-in fade-in zoom-in duration-700">
      <div class="icon-blob mb-10">
        <md-icon class="mail-icon"><IconMail /></md-icon>
      </div>
      
      <h1 class="text-3xl font-bold mb-4 tracking-tight text-primary">
        {{ $t('feedback.title') }}
      </h1>
      
      <p class="text-secondary text-lg mb-10 leading-relaxed">
        {{ $t('feedback.message') }}
      </p>

      <div class="email-display-container mb-10">
        <span class="text-xs uppercase tracking-widest text-secondary/60 font-bold block mb-2">
          {{ $t('feedback.contactUs') }}
        </span>
        <a href="mailto:info@boondogglelabs.com" class="email-text text-xl md:text-2xl font-semibold hover:opacity-70 transition-opacity">
          info@boondogglelabs.com
        </a>
      </div>

      <a href="mailto:info@boondogglelabs.com" class="no-underline inline-block">
        <md-filled-button class="send-button px-10">
          <md-icon slot="icon"><IconSend /></md-icon>
          {{ $t('feedback.send') }}
        </md-filled-button>
      </a>
    </div>

    <p class="mt-8 text-secondary/40 text-sm font-medium italic">
      {{ $t('feedback.featureIdeas') }}
    </p>
  </div>
</template>

<script setup>
import '@material/web/button/filled-button.js';
import '@material/web/icon/icon.js';

import IconMail from '~icons/material-symbols/mail-rounded';
import IconSend from '~icons/material-symbols/send-rounded';
</script>

<style scoped>
@reference "../assets/main.css";

.feedback-card {
  background: var(--color-surface);
  border: 1px solid var(--color-border-default);
  box-shadow: 0 24px 48px -12px rgba(0, 0, 0, 0.08);
}

.icon-blob {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90px;
  height: 90px;
  background: color-mix(in srgb, var(--color-rain) 12%, transparent);
  border-radius: 35% 65% 65% 35% / 35% 35% 65% 65%;
  margin: 0 auto;
  animation: blob-animate 8s infinite ease-in-out;
}

@keyframes blob-animate {
  0%, 100% { border-radius: 35% 65% 65% 35% / 35% 35% 65% 65%; }
  33% { border-radius: 65% 35% 35% 65% / 65% 65% 35% 35%; }
  66% { border-radius: 45% 55% 45% 55% / 55% 45% 55% 45%; }
}

.mail-icon {
  --md-icon-size: 42px;
  color: var(--color-rain);
}

.email-text {
  color: var(--color-primary);
  text-decoration: none;
}

.send-button {
  --md-filled-button-container-color: var(--color-rain);
  --md-filled-button-container-shape: 20px;
  height: 56px;
  font-size: 1.1rem;
}

:where(.dark) .feedback-card {
  box-shadow: 0 24px 48px -12px rgba(0, 0, 0, 0.4);
  background: var(--color-zinc-800);
}

:where(.dark) .icon-blob {
  background: color-mix(in srgb, var(--color-rain) 20%, transparent);
}
</style>
